import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '@/shared/ui';

import { patientAgentMessages } from '../config';

import styles from './AgentChat.module.scss';

type DocumentCardProps = {
  item: {
    id: string;
    title: string;
    documentID: string;
    action: 'created' | 'updated';
  };
  /** Discard is offered only where the fullscreen floating chat shows it. */
  showDiscard?: boolean;
  discardingDocumentID: string;
  className?: string;
  onOpenDocument: (documentID: string) => void;
  onDiscardDocument: (documentID: string) => void;
};

/** Compact document reference shown after the agent creates or updates a doc. */
export const DocumentCard: FC<DocumentCardProps> = ({
  item,
  showDiscard = false,
  discardingDocumentID,
  onOpenDocument,
  onDiscardDocument,
  className,
}) => {
  const { formatMessage } = useIntl();
  return (
    <section className={cn(styles.documentCard, className)}>
      <Icon name="doc" size={16} />
      <span className={styles.documentCardTitle} title={item.title}>
        {item.title}
      </span>
      <span className={styles.documentCardActions}>
        <span className={styles.documentCardStatus}>
          {item.action === 'created'
            ? formatMessage(patientAgentMessages.documentDraftCreated)
            : formatMessage(patientAgentMessages.documentUpdated)}
        </span>
        <button
          type="button"
          className={styles.documentCardOpen}
          onClick={() => onOpenDocument(item.documentID)}
        >
          {formatMessage({
            id: 'patientDocuments.open',
            defaultMessage: 'Open',
          })}
        </button>
        {showDiscard ? (
          <button
            type="button"
            className={styles.documentDiscardButton}
            disabled={discardingDocumentID === item.documentID}
            onClick={() => void onDiscardDocument(item.documentID)}
          >
            {discardingDocumentID === item.documentID
              ? formatMessage(patientAgentMessages.discarding)
              : formatMessage(patientAgentMessages.discard)}
          </button>
        ) : null}
      </span>
    </section>
  );
};
